import gql from 'graphql-tag'

export const GET_HERO_LIST = gql`
  query GetHeroes($heroType: [String!]) {
    heroes(heroType: $heroType) {
      id
      email
      heroType
      name
      firstname
      lastname
      tel
      address
      subDistrict
      district
      province
      zipcode
      lineId
      avatar {
        id
        url
      }

      plateLicense
      purpose
      postalAddress

      status
    }

    statusOptions: __type(name: "HeroStatus") {
      options: enumValues {
        name
      }
    }
    heroTypeOptions: __type(name: "HeroType") {
      options: enumValues {
        name
      }
    }
  }
`

export const GET_HERO_BY_ID = gql`
  query GetHeroById($id: Int!) {
    hero(id: $id) {
      id
      email
      heroType
      name
      firstname
      lastname
      tel
      address
      subDistrict
      district
      province
      zipcode
      lineId
      avatar {
        id
        url
      }
      maxLocation
      radius
      configByHero
      plateLicense
      purpose
      postalAddress

      idCard {
        name
        url
      }
      pictures {
        id
        name
        url
      }
      locations {
        id
        lat
        lng
        address
        radius
      }
      products {
        id
        material {
          id
          category {
            id
            name
          }
          name
          commonName
          cover {
            id
            url
          }
        }
        minQuantity
      }

      status
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/Hero.js